let params, originalParams = {
    voice: '0',
    volume: '100',
    range: '20',
    questionsQuantity: '10',
    correctInstantly: true,
}

if (localStorage.params) {
    params = JSON.parse(localStorage.params)
    // Doesn't work for deeply undefined properties
    for (let key in originalParams) {
        if (typeof params[key] === 'undefined') {
            params[key] = originalParams[key]
        }
    }
} else {
    params = structuredClone(originalParams)
}

export const trainNumbersModule = {
    namespaced: true,
    state: {
        originalParams,
        params,
        questionModes: {
            text: {
                questionProp: 'text'
            },
            number: {
                questionProp: 'index'
            }
        },
        inputModes: {
            text: {
                regex: /^[აბგდევზთიკლმნოპჟრსტუფქღყშჩცძწჭხჯჰ]{1,30}$/,
                placeholder: 'Число прописью грузинскими буквами...',
                validationMessage: 'Пожалуйста, напишите представленное число прописью.',
                answerProp: 'text'
            },
            number: {
                regex: /^\d{1,4}$/,
                placeholder: '',
                validationMessage: 'Пожалуйста, напишите представленное число цифрами.',
                answerProp: 'index'
            }
        },
        currentQuestionMode: 'text',
        currentInputMode: 'number',
    },
    getters: {
        paramsChanged (state) {
            return JSON.stringify(state.params) !== JSON.stringify(state.originalParams)
        },
    },
    mutations: {
        CANCEL_PARAMS_CHANGES (state) {
            state.params = JSON.parse(localStorage.params)
        },
        RESET_PARAMS_TO_DEFAULT (state) {
            state.params = structuredClone(originalParams)
        },
        UPDATE_PARAM (state, data) {
            state.params[data.key] = data.value
        },
    },
    actions: {
        saveParams ({state, getters, commit, dispatch}) {
            localStorage.params = JSON.stringify(state.params)
        },
    }
}
